// extracted by mini-css-extract-plugin
export default {"submitButtonDesktop":"submitAgreement-module__submitButtonDesktop__eCjYm"};